module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.f746247a.png";